import { Translation } from 'primeng/api';

/**
 * Textos en español de los componentes PrimeNG envueltos por la librería de componentes
 * (calendario: lunes como primer día, formato dd/mm/aa, botones "Hoy"/"Limpiar", navegación y confirmaciones).
 * Se registra en `providePrimeNG`.
 */
export const TRADUCCION_PRIMENG_ES: Translation = {
  accept: 'Aceptar',
  reject: 'Rechazar',
  choose: 'Seleccionar',
  clear: 'Limpiar',
  today: 'Hoy',
  dayNames: ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'],
  dayNamesShort: ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'],
  dayNamesMin: ['D', 'L', 'M', 'X', 'J', 'V', 'S'],
  monthNames: [
    'enero',
    'febrero',
    'marzo',
    'abril',
    'mayo',
    'junio',
    'julio',
    'agosto',
    'septiembre',
    'octubre',
    'noviembre',
    'diciembre',
  ],
  monthNamesShort: [
    'ene',
    'feb',
    'mar',
    'abr',
    'may',
    'jun',
    'jul',
    'ago',
    'sep',
    'oct',
    'nov',
    'dic',
  ],
  chooseDate: 'Elegir fecha',
  chooseMonth: 'Elegir mes',
  chooseYear: 'Elegir año',
  prevDecade: 'Década anterior',
  nextDecade: 'Década siguiente',
  prevYear: 'Año anterior',
  nextYear: 'Año siguiente',
  prevMonth: 'Mes anterior',
  nextMonth: 'Mes siguiente',
  prevHour: 'Hora anterior',
  nextHour: 'Hora siguiente',
  prevMinute: 'Minuto anterior',
  nextMinute: 'Minuto siguiente',
  prevSecond: 'Segundo anterior',
  nextSecond: 'Segundo siguiente',
  am: 'a. m.',
  pm: 'p. m.',
  dateFormat: 'dd/mm/yy',
  firstDayOfWeek: 1,
  weekHeader: 'Sem',
};
